import Details from '@/components/Details/Details';
import useApplicationConfig from '@/hooks/useApplicationConfig';
import IEventType from '@/types/IEventType';
import { IEventTypeWrite } from '@/types/apiClient/IEventTypeWrite';
import { Box, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FcCalendar } from 'react-icons/fc';
import ConnectedCalendars from './components/ConnectedCalendars/ConnectedCalendars';

export interface ISectionCalendarsProps {
	isLoading: boolean;
	service: IEventType;
	onChange: (values: Partial<IEventTypeWrite>) => void;
}

export default function SectionCalendars(props: ISectionCalendarsProps) {
	const { t } = useTranslation();
	const appConfig = useApplicationConfig();

	if (!appConfig.hasThirdPartyCalendarsEnabled) {
		return null;
	}

	return (
		<Details image={<FcCalendar />} title={t('Connected calendars')}>
			<Box p="4" background="blue.50" borderRadius="sm" fontSize="sm" mb="4">
				<Text mb="2">
					{t(
						'Connect your calendars and sync them with this booking page to check availability or create events on them.'
					)}
				</Text>

				<UnorderedList>
					<ListItem>
						<b>{t('Availability check')}:</b> {t('The slots will be disabled if you have events scheduled.')}
					</ListItem>
					<ListItem>
						<b>{t('Event creation')}</b>{' '}
						{t('When a booking is made, an event will be created in that calendar.')}
					</ListItem>
				</UnorderedList>
			</Box>

			<ConnectedCalendars
				isLoading={props.isLoading}
				service={props.service}
				onChange={(thirdPartyCalendars) => props.onChange({ thirdPartyCalendars })}
			/>
		</Details>
	);
}
